import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';
import { defineMessages } from 'react-intl';

import ListingPersonsEdit from './ListingPersonsEdit';
import ListingPersonsView from './ListingPersonsView';

import iconSVG from '@plone/volto/icons/user.svg';

defineMessages({
  listingPersons: {
    id: 'Listing persons',
    defaultMessage: 'Listing persons',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.listingPersonsBlock = {
    id: 'listingPersonsBlock',
    title: 'Listing persons',
    group: 'organization',
    icon: iconSVG,
    view: ListingPersonsView,
    edit: ListingPersonsEdit,
    restricted: OnlyContentTypes(['Area']),
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
